import { styled, Table as MuiTable } from "@mui/material";
import { solitude } from "shared/assets/colors";

const PREFIX = "ProductOverviewStyles";
export const classes = {
  table: `${PREFIX}-table`,
};

export const Table = styled(MuiTable)(() => ({
  [`&.${classes.table}`]: {
    border: `1px solid ${solitude}`,
    borderCollapse: "separate",
    borderSpacing: "5px !important",
  },
}));
